import readXlsxFile from 'read-excel-file';
// import firebase from 'firebase';
import React from 'react';
import { withAuthorization } from '../Session';

import Form from 'react-bootstrap/Form';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
//import { withFirebase } from "../Firebase";
import YearMonthPicker from 'react-year-month-picker';
import { Container, Row, Col } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import ViewBonusData from '../ViewBonusData';
import convertMonthToNumeric from '../Utilities';
import Alert from 'react-bootstrap/Alert';

import RestServices from '../services/RestServices.js';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360
        //   backgroundColor: theme.palette.background.paper,
    }
}));

function CheckboxList(props) {
    const classes = useStyles();
    const [checked, setChecked] = React.useState([]);

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        props.uploadExcelData(newChecked);
        setChecked(newChecked);
    };

    return (
        <div>
            <List className={classes.root}>
                <h5>Select sheets to upload</h5>
                {props.sheetNames.map((value, index) => {
                    const labelId = `checkbox-list-label-${index}`;

                    return (
                        <ListItem
                            key={value.name}
                            role={undefined}
                            dense
                            button
                        >
                            <ListItemIcon>
                                <Checkbox
                                    onClick={handleToggle(index)}
                                    edge="start"
                                    //   checked={checked.indexOf(index) !== -1}

                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': labelId }}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={value.name} />
                        </ListItem>
                    );
                })}
                <hr />
            </List>
        </div>
    );
}

class BonusPayout extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            showLoading: false,
            sheetsFlag: 0,
            showallSheetsSumRecords: 0,
            isFileAlreadyUploaded: 2,
            selectedSheets: [],
            allSheets: [],
            allSheetsSumRecords: [],
            scheduled:
                new Date().getFullYear() + '-' + new Date().getMonth() + 1,
            data: [],
            sheetStatus: '',
            ExecutedSheets: 1,
            allStoreTagSumRecords: [],
            alert: 0,
            alertMessage: ''
        };
    }

    sheetNames = [];
    tempArr = [];
    file = null;

    async componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleOnChange = async (event) => {
        if (this._isMounted) {
            this.setState({
                sheetsFlag: 2,
                showLoading: true,
                sheetStatus: 'Processing Doc please wait...'
            });
        }
        this.sheetNames = [];

        if (event.target.files.length > 0) {
            this.file = event.target.files[0];

            const excelUtility = () => {
                this.sheetNames.forEach((value) => {
                    this.tempArr.push(value.name);
                });

                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        sheetStatus: '',
                        sheetsFlag: 1
                    });
                }
            };
            await readXlsxFile(event.target.files[0], { getSheets: true })
                .then(async (sheets) => {
                    this.sheetNames = await sheets;
                    await excelUtility();
                })
                .catch(function (error) {
                   
                });
        }
    };

    uploadData = async () => {
        if (this._isMounted) {
            this.setState({ sheetStatus: 'Processing sheets please wait...' });
        }
        let mapCustomerRecords = [];
        let walletTransactionMap = [];

        var dataProcessor = async () => {
            var UpdateStoreIncentives = async (data) => {
                let d = data;
                this.setState({
                    sheetStatus:
                        'Sheet:' +
                        this.state.ExecutedSheets +
                        ' Executing Sheet ' +
                        d[0]
                });
                let headings = d[1][0];
                let dictionary = {};

                for (let i = 0; i < headings.length; i++) {
                    dictionary[headings[i]] = i;
                }

                let rows = d[1];
                let tagId = dictionary['Tag'];

                await RestServices.updateIncentivesMetadata(
                    localStorage.getItem('FirebaseToken'),
                    this.state.scheduled,
                    d[0],
                    JSON.stringify(headings)
                )
                    .then((response) => response.json())
                    .then((responseData) => {
                        if (responseData.error) {
                            if (this._isMounted) {
                                this.setState({
                                    showLoading: false,
                                    alert: 1,
                                    alertMessage: responseData.error
                                });
                            }
                        } else {
                            if (responseData.success) {
                                for (let i = 0; i < rows.length; i++) {
                                    if (
                                        !(rows[i][tagId] in mapCustomerRecords)
                                    ) {
                                        let eachRecord = {};
                                        for (
                                            let j = 0;
                                            j < headings.length;
                                            j++
                                        ) {
                                            if (headings[j] !== 'Tag') {
                                                eachRecord[headings[j]] =
                                                    rows[i][
                                                        dictionary[headings[j]]
                                                    ];
                                            }
                                            if (headings[j] === 'TotalPay') {
                                                walletTransactionMap[
                                                    rows[i][tagId]
                                                ] = {
                                                    sum: rows[i][
                                                        dictionary[headings[j]]
                                                    ]
                                                };
                                            }
                                        }
                                        mapCustomerRecords[rows[i][tagId]] = {
                                            [d[0]]: eachRecord,
                                            Tag: rows[i][tagId],
                                            Date: this.state.scheduled
                                        };
                                    } else {
                                        let eachRecord = {};
                                        for (
                                            let j = 0;
                                            j < headings.length;
                                            j++
                                        ) {
                                            if (headings[j] !== 'Tag') {
                                                eachRecord[headings[j]] =
                                                    rows[i][
                                                        dictionary[headings[j]]
                                                    ];
                                            }
                                            if (headings[j] === 'TotalPay') {
                                                walletTransactionMap[
                                                    rows[i][tagId]
                                                ].sum +=
                                                    rows[i][
                                                        dictionary[headings[j]]
                                                    ];
                                            }
                                        }
                                        mapCustomerRecords[rows[i][tagId]][
                                            d[0]
                                        ] = eachRecord;
                                    }

                                    if (i === rows.length - 1) {
                                        if (
                                            this.state.ExecutedSheets >=
                                            this.state.selectedSheets.length
                                        ) {
                                            this.data = [];
                                            this.tempArr = [];
                                            this.file = null;
                                            this.sheetNames = [];
                                            if (this._isMounted) {
                                                this.setState({
                                                    showLoading: false,
                                                    sheetsFlag: 0,
                                                    selectedSheets: [],
                                                    sheetStatus:
                                                        'All sheets sxecuted....'
                                                });
                                            }
                                            this.checkIfSheetUploaded();
                                        } else {
                                            var ExecutedSheets =
                                                parseInt(
                                                    this.state.ExecutedSheets
                                                ) + 1;
                                            if (this._isMounted) {
                                                this.setState({
                                                    ExecutedSheets:
                                                        ExecutedSheets
                                                });
                                            }
                                        }
                                    } else {
                                        if (this._isMounted) {
                                            this.setState({
                                                sheetStatus:
                                                    'Executing sheet: ' + d[0]
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    })
                    .catch((err) => {
                        if (this._isMounted) {
                            this.setState({
                                showLoading: false,
                                showallSheetsSumRecords: 0,
                                isFileAlreadyUploaded: 0,
                                alert: 1,
                                alertMessage: err.message
                            });
                        }
                    });

                let mapCustomerRecordsKeys = Object.keys(mapCustomerRecords);
                await mapCustomerRecordsKeys.forEach(async (key) => {
                    let recordMap = {};
                    Object.keys(mapCustomerRecords[key]).forEach((key1) => {
                        recordMap[key1] = mapCustomerRecords[key][key1];
                    });
                    if (key !== 'Tag') {
                        await RestServices.updateStoreIncentives(
                            localStorage.getItem('FirebaseToken'),
                            key + '_' + this.state.scheduled,
                            JSON.stringify(recordMap)
                        )
                            .then((response) => response.json())
                            .then((responseData) => {
                                if (responseData.error) {
                                    if (this._isMounted) {
                                        this.setState({
                                            showLoading: false,
                                            alert: 1,
                                            alertMessage: responseData.error
                                        });
                                    }
                                } else {
                                }
                            });
                    }
                });
            };

            var arrDataOutLoop = async (value, data) => {
                if (
                    data[0].indexOf('Tag') !== -1 &&
                    data[0].indexOf('TotalPay') !== -1
                ) {
                    try {
                        await RestServices.UpdateStoreIncentivesUpdationDates(
                            localStorage.getItem('FirebaseToken'),
                            this.state.scheduled,
                            value
                        )
                            .then((response) => response.json())
                            .then((responseData) => {
                                if (responseData.error) {
                                    if (this._isMounted) {
                                        this.setState({
                                            showLoading: false,
                                            alert: 1,
                                            alertMessage: responseData.error
                                        });
                                    }
                                } else {
                                    
                                }
                            })
                            .catch((err) => {
                                if (this._isMounted) {
                                    this.setState({
                                        showLoading: false,
                                        showallSheetsSumRecords: 0,
                                        isFileAlreadyUploaded: 0,
                                        alert: 1,
                                        alertMessage: err.message
                                    });
                                }
                            });

                        await UpdateStoreIncentives([value, data]);
                    } catch (error) {
                        if (this._isMounted) {
                            this.setState({
                                alert: 1,
                                alertMessage: error.message
                            });
                        }
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: 'No tag found....'
                        });
                    }
                }
            };

            if (this._isMounted) {
                this.setState({ sheetsFlag: 2 });
            }
            this.tempArr.forEach(async (value, index) => {
                let currIndex = this.state.selectedSheets.indexOf(index);

                if (currIndex !== -1) {
                    await readXlsxFile(this.file, { sheet: value }).then(
                        async (data1) => {
                            await arrDataOutLoop(value, data1);
                        }
                    );
                }
            });
        };
        if (this._isMounted) {
            this.setState({ showLoading: true });
        }
        await dataProcessor();
    };

    handleChange = async (m) => {
        if (this._isMounted) {
            this.setState({ scheduled: convertMonthToNumeric(m._i) });
            this.setState({
                showallSheetsSumRecords: 0,
                isFileAlreadyUploaded: 2
            });
        }
    };

    reUpload = async () => {
        if (this._isMounted) {
            this.setState({
                showallSheetsSumRecords: 0,
                isFileAlreadyUploaded: 0
            });
        }
    };

    submitForApproval = async () => {
        //this.setState({isFileAlreadyUploaded: 0});
        if (this._isMounted) {
            this.setState({
                showallSheetsSumRecords: 0,
                isFileAlreadyUploaded: 0,
                alert: 1,
                alertMessage: 'New Sheet Notification sent to admin...'
            });
        }
    };

    approvePublish = async () => {
        if (this._isMounted) {
            this.setState({ showLoading: true });
        }

        await RestServices.approvePublishIncentives(
            localStorage.getItem('FirebaseToken'),
            this.state.scheduled
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            showLoading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (responseData) {
                        this.UpdateWalletHistory();
                    } else {
                        if (this._isMounted) {
                            this.setState({
                                showLoading: false,
                                showallSheetsSumRecords: 0,
                                isFileAlreadyUploaded: 0,
                                alert: 1,
                                alertMessage: 'Oops! something went wrong...'
                            });
                        }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        showallSheetsSumRecords: 0,
                        isFileAlreadyUploaded: 0,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    };

    UpdateWalletHistory = async () => {
        let walletTransactionMap = this.state.allStoreTagSumRecords;
        let walletTransactionMapKeys = Object.keys(walletTransactionMap);
        let keyCount = 0;
        walletTransactionMapKeys.forEach(async (key) => {
            let easyOrNonEasyVariable = '';
            for (let i = 0; i < 4; i++) easyOrNonEasyVariable += key[i];
            let calculatedAmount = 0;

            if (easyOrNonEasyVariable === 'easy') {
                calculatedAmount += walletTransactionMap[key].sum;
                calculatedAmount -= calculatedAmount * (0 / 100);
                calculatedAmount -= calculatedAmount * (0 / 100);
            } else {
                calculatedAmount += walletTransactionMap[key].sum;
                calculatedAmount -= calculatedAmount * (0 / 100);
                calculatedAmount -= calculatedAmount * (0 / 100);
            }

            const walletUpdater = async (currentBalance) => {
                await RestServices.updateWalletTransactionHistory(
                    localStorage.getItem('FirebaseToken'),
                    key,
                    currentBalance,
                    calculatedAmount
                )
                    .then((response) => response.json())
                    .then((responseData) => {
                        if (responseData.error) {
                            
                        } else {
                            keyCount = keyCount + 1;
                            if (keyCount === walletTransactionMapKeys.length) {
                                if (this._isMounted) {
                                    this.setState({
                                        showLoading: false,
                                        showallSheetsSumRecords: 0
                                    });
                                }
                            }
                        }
                    })
                    .catch((err) => {
                       
                    });
            };

            await RestServices.getAllStoreWallet(
                localStorage.getItem('FirebaseToken'),
                key
            )
                .then((response) => response.json())
                .then((responseData) => {
                    if (responseData.error) {
                        
                    } else {
                        walletUpdater(responseData.currentBalance);
                    }
                })
                .catch((err) => {
                    
                });
        });
    };

    checkIfSheetUploaded = async () => {
        if (this._isMounted) {
            this.setState({ showallSheetsSumRecords: 0, showLoading: true });
        }

        await RestServices.checkIfSheetUploaded(
            localStorage.getItem('FirebaseToken'),
            this.state.scheduled
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            showLoading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (responseData.SheetUploaded) {
                        this.getPreviousSheetData();
                    } else {
                        if (this._isMounted) {
                            this.setState({
                                showLoading: false,
                                showallSheetsSumRecords: 0,
                                isFileAlreadyUploaded: 0
                            });
                        }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        showallSheetsSumRecords: 0,
                        isFileAlreadyUploaded: 0,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    };

    getPreviousSheetData = async () => {
        

        let allSheetsSumRecords = [];
        let allStoreTagSumRecordsBH = [];

        await RestServices.getPreviousSheetData(
            localStorage.getItem('FirebaseToken'),
            this.state.scheduled
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: 0,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    let allSheets = responseData.sheets;
                    if (this._isMounted) {
                        this.setState({
                            allSheets: allSheets,
                            showallSheetsSumRecords: 1,
                            isFileAlreadyUploaded: 1
                        });
                    }
                    let numCallbackRuns = 0;

                    allSheets.forEach(async (sheetName, index) => {
                        //await RestServices.getAllStoreTags(localStorage.getItem('FirebaseToken'))
                        await RestServices.getAllStoresMappedWith(
                            localStorage.getItem('FirebaseToken'),
                            this.props.user.ProfileUniqeID,
                            this.props.role == 'StoreOwners'
                                ? 'StoreOwner'
                                : this.props.role
                        )
                            .then((response) => response.json())
                            .then((StoreTags) => {
                                if (StoreTags.error) {
                                    if (this._isMounted) {
                                        this.setState({
                                            flag: 0,
                                            alert: 1,
                                            alertMessage: StoreTags.error
                                        });
                                    }
                                } else {
                                    let numInnerCallbackRuns = 0;
                                    StoreTags.forEach(async (value, index2) => {
                                        await RestServices.getAllStoreIncentives(
                                            this.props.firebase.auth.currentUser
                                                .accessToken,
                                            'Validate-StoreIncentives',
                                            value.concat(
                                                '_',
                                                this.state.scheduled
                                            )
                                        )
                                            .then((response) => response.json())
                                            .then((responseDataBH) => {
                                                if (StoreTags.error) {
                                                    if (this._isMounted) {
                                                        this.setState({
                                                            flag: 0,
                                                            alert: 1,
                                                            alertMessage:
                                                                responseDataBH.error
                                                        });
                                                    }
                                                } else {
                                                    var responseData =
                                                        responseDataBH.data;
                                                    if (
                                                        responseData &&
                                                        responseData[sheetName]
                                                    ) {
                                                        if (
                                                            responseData[
                                                                sheetName
                                                            ].TotalPay > 0
                                                        ) {
                                                            var TotalPayValue =
                                                                parseFloat(
                                                                    responseData[
                                                                        sheetName
                                                                    ].TotalPay
                                                                );
                                                        } else {
                                                            var TotalPayValue = 0;
                                                        }

                                                        if (
                                                            !(
                                                                value in
                                                                allStoreTagSumRecordsBH
                                                            )
                                                        ) {
                                                            allStoreTagSumRecordsBH[
                                                                value
                                                            ] = {
                                                                sum: TotalPayValue
                                                            };
                                                        } else {
                                                            allStoreTagSumRecordsBH[
                                                                value
                                                            ].sum += TotalPayValue;
                                                        }
                                                        if (this._isMounted) {
                                                            this.setState({
                                                                allStoreTagSumRecords:
                                                                    allStoreTagSumRecordsBH
                                                            });
                                                        }

                                                        if (
                                                            !(
                                                                sheetName in
                                                                allSheetsSumRecords
                                                            )
                                                        ) {
                                                            allSheetsSumRecords[
                                                                sheetName
                                                            ] = {
                                                                sum: TotalPayValue
                                                            };
                                                        } else {
                                                            allSheetsSumRecords[
                                                                sheetName
                                                            ].sum += TotalPayValue;
                                                        }
                                                        if (this._isMounted) {
                                                            this.setState({
                                                                allSheetsSumRecords:
                                                                    allSheetsSumRecords,
                                                                showallSheetsSumRecords: 1
                                                            });
                                                        }
                                                    }
                                                }
                                            });

                                        numInnerCallbackRuns++;
                                        if (
                                            numInnerCallbackRuns ===
                                            StoreTags.length
                                        ) {
                                            numCallbackRuns++;
                                           

                                            if (
                                                numCallbackRuns ===
                                                allSheets.length
                                            ) {
                                               
                                                if (this._isMounted) {
                                                    this.setState({
                                                        showLoading: false,
                                                        showallSheetsSumRecords: 1,
                                                        isFileAlreadyUploaded: 1
                                                    });
                                                }
                                            }
                                        }
                                    });
                                }
                            });
                    });
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: 0,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    };

    render() {
        let allSheetsSumRecords = this.state.allSheetsSumRecords;

        let durationBody = this.state.allSheets.map((key) => {
            if (allSheetsSumRecords[key]) {
                var sum = allSheetsSumRecords[key].sum;
            } else {
                var sum = 0;
            }
            return (
                <tr key={key}>
                    <td>{key}</td>
                    <td>
                        <b>{sum}</b>
                    </td>
                </tr>
            );
        });

        return (
            <Container>
                <Row>
                    <h5 style={{ marginLeft: '1rem' }}>Monthly Bonus</h5>
                </Row>
                <div>
                    <hr />
                </div>

                <Tabs defaultActiveKey="view" id="uncontrolled-tab-example">
                    <Tab eventKey="view" title="View Details">
                        <ViewBonusData fb={this.props.firebase} />
                    </Tab>

                    <Tab
                        eventKey="upload"
                        title="Upload Data"
                        style={{ height: '700px' }}
                    >
                        <div>
                            <h5 style={{ marginTop: '10px' }}>
                                {this.state.sheetStatus}
                            </h5>
                            {this.state.alert === 1 && (
                                <Alert variant="danger">
                                    {this.state.alertMessage}
                                </Alert>
                            )}
                            {this.state.showLoading && (
                                <Spinner animation="border" />
                            )}
                        </div>
                        {this.state.sheetsFlag === 0 && (
                            <div>
                                <br />
                                <h5 style={{ marginTop: '10px' }}>
                                    Upload Bonus/Incentives Data
                                </h5>
                                <br />
                                <Row>
                                    <Col sm={2}>
                                        <label>Select Date:</label>
                                    </Col>
                                    <Col sm={3}>
                                        <YearMonthPicker
                                            closeOnSelect
                                            defaultYear={new Date().getFullYear()}
                                            defaultMonth={
                                                new Date().getMonth() + 1
                                            }
                                            minYear={
                                                new Date().getFullYear() - 5
                                            }
                                            maxYear={new Date().getFullYear()}
                                            onChange={this.handleChange.bind(
                                                this
                                            )}
                                        />
                                        <p
                                            style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}
                                        >
                                            *Select Month and Year before you
                                            upload
                                        </p>

                                        {this.state.isFileAlreadyUploaded ===
                                            2 && (
                                            <Button
                                                variant="primary"
                                                onClick={() =>
                                                    this.checkIfSheetUploaded()
                                                }
                                            >
                                                Check If Sheet Uploaded
                                            </Button>
                                        )}
                                    </Col>
                                </Row>

                                <br />

                                {this.state.showallSheetsSumRecords === 1 && (
                                    <div>
                                        <p>
                                            <b>
                                                Total Payout Summary for{' '}
                                                {this.state.scheduled}
                                            </b>
                                        </p>
                                        <table style={{ margin: '10px 0px' }}>
                                            <tbody>
                                                {durationBody}

                                                {!this.state.showLoading && (
                                                    <tr>
                                                        <td>
                                                            <Button
                                                                variant="primary"
                                                                onClick={() =>
                                                                    this.reUpload()
                                                                }
                                                            >
                                                                Re-Upload
                                                            </Button>
                                                        </td>
                                                        <td>
                                                            <Button
                                                                variant="primary"
                                                                onClick={() =>
                                                                    this.submitForApproval()
                                                                }
                                                            >
                                                                Submit For
                                                                Approval
                                                            </Button>

                                                            {this.props.role ===
                                                                'Admin' && (
                                                                <Button
                                                                    variant="primary"
                                                                    style={{
                                                                        marginLeft:
                                                                            '1rem'
                                                                    }}
                                                                    onClick={() =>
                                                                        this.approvePublish()
                                                                    }
                                                                >
                                                                    Approve &
                                                                    Publish
                                                                </Button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}

                                {this.state.isFileAlreadyUploaded === 0 && (
                                    <div>
                                        <Row>
                                            <Col sm={2}>
                                                <label>Choose File:</label>
                                            </Col>
                                            <Col sm={3}>
                                                <Form>
                                                    <Form.File
                                                        id="custom-file-translate-scss"
                                                        lang="en"
                                                        onChange={
                                                            this.handleOnChange
                                                        }
                                                        accept=".xlsx, .xls"
                                                    />
                                                    <p
                                                        style={{
                                                            color: 'red',
                                                            fontSize: '12px'
                                                        }}
                                                    >
                                                        Choose .xls(x) file to
                                                        proceed further
                                                    </p>
                                                </Form>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Alert variant="warning">
                                                Make sure each sheet in the file
                                                contains two mandatory fields
                                                "Tag" and "TotalPay"
                                                (case-sensitive)
                                            </Alert>
                                        </Row>

                                        <hr />
                                    </div>
                                )}
                            </div>
                        )}

                        {this.state.sheetsFlag === 1 && (
                            <div>
                                <CheckboxList
                                    sheetNames={this.sheetNames}
                                    uploadExcelData={(sheets) =>
                                        this.setState({
                                            selectedSheets: sheets
                                        })
                                    }
                                />

                                {this.state.selectedSheets.length > 0 ? (
                                    <Button
                                        variant="primary"
                                        onClick={() => this.uploadData()}
                                    >
                                        Upload
                                    </Button>
                                ) : (
                                    <Button variant="primary" disabled>
                                        Upload
                                    </Button>
                                )}

                                <Button
                                    variant="primary"
                                    style={{ marginLeft: '1rem' }}
                                    onClick={() => {
                                        this.setState({ sheetsFlag: 0 });
                                        this.tempArr = [];
                                        this.sheetNames = [];
                                        this.file = null;
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        )}
                    </Tab>
                </Tabs>
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(BonusPayout);
